module.exports = __webpack_public_path__ + "img/it-pathway.1cb245da.jpg";